import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 10px;
  min-width: 500px;
`;

export const WrapperInput = styled.div`
  margin-bottom: 20px;
`;

export const WrapperButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

